export function immoTagsReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_IMMO_TAG":            
        case "UPDATE_IMMO_TAG":
            let list = Object.assign({}, state);
            list[payload.label_id] = payload
        
            return list
            
        case "GET_IMMO_TAGS":

            return payload
            
        default:
            return state;
    }
    
}